export const dashboardRoutes = {
  path: "/dashboard",
  to: "/dashboard",
  icon: "mdi-view-dashboard",
  activeRoutes: ["dashboard"],
  meta: {
    title: "dashboard",
  },
  showInMenu: true,
  order: 1,
  component: () => import("@/views/home"),
  children: [
    {
      path: "/",
      component: () => import("@/views/home"),
      name: "dashboard",
      icon: "mdi-file-document-multiple-outline",
      to: "/dashboard",
      allowed: false,
      meta: {
        title: "dashboard",

      }
    },
  ]
};
